import { en } from './EN';
import { id } from './ID';
import { jp } from './JP';

export const Lang = {
    en,
    id,
    jp
}
